import script from "./menu-item.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-item.vue?vue&type=script&setup=true&lang=js"

import "./menu-item.vue?vue&type=style&index=0&id=495cdc82&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-495cdc82"]])

export default __exports__